const formatDate = (dateObject) => {
  if (!(dateObject instanceof Date)) throw new Error('wrong date format, should be date object');
  const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(dateObject)
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(dateObject)
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(dateObject)
  return `${mo}/${da}/${ye}`
}

export default formatDate;
